
import { CartItems } from "../Interface/Order.interface";
import { axiosInstance } from "./Api";



const orderServices = {


    postOrderService: async (payload: CartItems[]): Promise<any> => {
        
        const response = await axiosInstance.post('EcomHome/SaveProductCarts', payload)
        return response.data
    },

    getTrackingOrders:async(memberId:number):Promise<any> => {
        
        const response= await axiosInstance.get(`EcomHome/GetOnlineTracking?memberid=${memberId}`)
        const jsonData = JSON.parse(response.data)
        return jsonData
    }
}

export default orderServices